import { useState, useEffect } from 'react'
import { Icons } from '../../../new-components/atoms'

interface Screen2Props {
  onSignDocument: () => Promise<void>
  loading: boolean
  onClose: () => void
  widget?: any
  signatureStatus?: 'pending' | 'completed'
}

const Screen2: React.FC<Screen2Props> = ({ onSignDocument, loading, onClose, widget, signatureStatus = 'pending' }) => {
  const [isToggleChecked, setIsToggleChecked] = useState(false)

  useEffect(() => {
    if (signatureStatus === 'completed') {
      console.log('Documento assinado com sucesso!')
    }
  }, [signatureStatus])

  return (
    <div
      style={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
      }}>
      <div
        className="header-section"
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: '32px',
          backgroundColor: '#fff',
          borderBottom: '1px solid #E3E3E3',
          padding: '24px',
        }}>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '8px'
          }}>
          <div
            style={{
              width: '24px',
              height: '24px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
            <Icons.ShoppingBag 
              width="34"
              height="34"
              color="#6B7B3C"
            />
          </div>
          <h2
            className="header-title"
            style={{
              fontSize: '1.25rem',
              fontWeight: '600',
              color: '#6B7B3C',
              margin: 0
            }}>
            Cannect cuida por você
          </h2>
        </div>
        <button
          onClick={onClose}
          style={{
            background: 'none',
            border: 'none',
            fontSize: '1.5rem',
            color: '#b7280',
            cursor: 'pointer',
            padding: '4px',
            borderRadius: '4px',
            transition: 'color 0.2s'
          }}>
          ×
        </button>
      </div>

      <div className="content-section" style={{ flex: 1, display: 'flex', flexDirection: 'column', padding: '0 24px' }}>
        <h3
          className="title-text"
          style={{
            fontSize: '1.5rem',
            fontWeight: '700',
            color: '#374151',
            marginBottom: '16px',
            textAlign: 'center'
          }}>
          {widget ? 'Confira sua procuração' : 'Assine digitalmente com segurança'}
        </h3>

        <p
          className="description-text"
          style={{
            color: '#6b7280',
            fontSize: '0.95rem',
            lineHeight: '1.6',
            marginBottom: '24px',
            textAlign: 'center'
          }}>
          {widget 
            ? 'Revise o documento abaixo e assine digitalmente para prosseguir.'
            : 'Para que a Cannect solicite sua autorização de importação junto à Anvisa, você precisa assinar a procuração digitalmente.'
          }
        </p>

        <div
          id="clicksign-container"
          className="widget-container"
          style={{
            backgroundColor: 'white',
            borderRadius: '8px',
            border: '1px solid #e5e7eb',
            height: '600px',
            width: '100%',
            overflow: 'hidden',
            display: widget ? 'block' : 'none'
          }}
        />
        
      
        {widget ? (
          <div
            className="toggle-section"
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '12px',
              padding: '16px',
            }}>
            <button
              onClick={() => setIsToggleChecked(!isToggleChecked)}
              style={{
                width: '44px',
                height: '24px',
                backgroundColor: isToggleChecked ? '#748351' : '#d1d5db',
                border: 'none',
                borderRadius: '12px',
                cursor: 'pointer',
                position: 'relative',
                transition: 'background-color 0.2s'
              }}>
              <div
                style={{
                  width: '18px',
                  height: '18px',
                  backgroundColor: 'white',
                  borderRadius: '50%',
                  position: 'absolute',
                  top: '3px',
                  left: isToggleChecked ? '23px' : '3px',
                  transition: 'left 0.2s'
                }}
              />
            </button>
            <span
              style={{
                fontSize: '0.9rem',
                color: '#374151',
                flex: 1
              }}>
              Assinar procuração para solicitar Autorização de Importação Anvisa
            </span>
          </div>
        ) : null}

        <p
          className="powered-by-text"
          style={{
            fontSize: '0.8rem',
            color: '#9ca3af',
            textAlign: 'start',
            marginLeft: '20px'
          }}>
          Powered by Clicksign®
        </p>
      </div>

      {!widget && (
        <div 
        className="button-section"
        style={{ padding: '0 24px 44px 24px' }}
        >
        <button
          onClick={onSignDocument}
          disabled={loading || !isToggleChecked}
          style={{
            width: '100%',
            background: loading || !isToggleChecked ? '#9ca3af' : '#748351',
            color: 'white',
            border: 'none',
            borderRadius: '8px',
            padding: '16px 24px',
            fontSize: '1rem',
            fontWeight: '600',
            cursor: loading || !isToggleChecked ? 'not-allowed' : 'pointer',
            transition: 'background-color 0.2s',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '8px'
          }}>
          {loading ? (
            <>
              <div
                style={{
                  width: '16px',
                  height: '16px',
                  border: '2px solid transparent',
                  borderTop: '2px solid white',
                  borderRadius: '50%',
                  animation: 'spin 1s linear infinite'
                }}
              />
              Assinando...
            </>
          ) : (
            'Assinar documento'
          )}
        </button>
        </div>
      )}

      <style>{`
        @keyframes spin {
          0% {
            transform: rotate(0deg);
          }
          100% {
            transform: rotate(360deg);
          }
        }

        /* Estilos para desktop - garantir espaçamentos adequados */
        @media (min-width: 769px) {
          .header-section {
            padding: 24px !important;
            margin-bottom: 32px !important;
          }
          
          .content-section {
            padding: 0 24px !important;
          }
          
          .title-text {
            font-size: 1.5rem !important;
            margin-bottom: 16px !important;
          }
          
          .description-text {
            font-size: 0.95rem !important;
            margin-bottom: 24px !important;
          }
          
          .widget-container {
            height: 600px !important;
          }
          
          .toggle-section {
            padding: 16px !important;
          }
          
          .powered-by-text {
            margin-left: 20px !important;
            font-size: 0.8rem !important;
          }
          
          .button-section {
            padding: 0 24px 44px 24px !important;
          }
        }

        @media (max-width: 768px) {
          .header-section {
            padding: 16px !important;
            margin-bottom: 24px !important;
          }
          
          .header-title {
            font-size: 1.1rem !important;
          }
          
          .content-section {
            padding: 0 16px !important;
          }
          
          .title-text {
            font-size: 1.3rem !important;
            margin-bottom: 12px !important;
          }
          
          .description-text {
            font-size: 0.9rem !important;
            margin-bottom: 20px !important;
          }
          
          .widget-container {
            height: 400px !important;
            border-radius: 6px !important;
          }
          
          .toggle-section {
            padding: 12px !important;
          }
          
          .powered-by-text {
            margin-left: 16px !important;
            margin-top: 16px !important;
            font-size: 0.75rem !important;
          }
          
          .button-section {
            padding: 0 16px 32px 16px !important;
          }
        }
        
        @media (max-width: 480px) {
          .header-section {
            padding: 12px !important;
            margin-bottom: 20px !important;
          }
          
          .header-title {
            font-size: 1rem !important;
          }
          
          .content-section {
            padding: 0 12px !important;
          }
          
          .title-text {
            font-size: 1.2rem !important;
            margin-bottom: 10px !important;
          }
          
          .description-text {
            font-size: 0.85rem !important;
            margin-bottom: 16px !important;
          }
          
          .widget-container {
            height: 350px !important;
            border-radius: 4px !important;
          }
          
          .toggle-section {
            padding: 10px !important;
            gap: 8px !important;
          }
          
          .powered-by-text {
            margin-left: 12px !important;
            margin-top: 16px !important;
            font-size: 0.7rem !important;
          }
          
          .button-section {
            padding: 0 12px 24px 12px !important;
          }
        }
      `}</style>
    </div>
  )
}

export default Screen2
